export function floatingTablePanelStyle(trigger, options = {}) {
  const {
    width = 208,
    height = 180,
    placement = "above",
    align = "center",
  } = options;
  const rect = trigger.getBoundingClientRect();
  const margin = 8;
  const gap = 6;
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const preferredTop =
    placement === "above" ? rect.top - height - gap : rect.bottom + gap;
  const fallbackTop =
    placement === "above" ? rect.bottom + gap : rect.top - height - gap;
  const top =
    preferredTop >= margin && preferredTop + height <= viewportHeight - margin
      ? preferredTop
      : fallbackTop;
  const left =
    align === "right"
      ? rect.right - width
      : rect.left + rect.width / 2 - width / 2;

  return {
    top: `${Math.max(
      margin,
      Math.min(top, viewportHeight - height - margin)
    )}px`,
    left: `${Math.max(
      margin,
      Math.min(left, viewportWidth - width - margin)
    )}px`,
  };
}
